module.exports = __webpack_public_path__ + "img/mesa_el_n.a8e23552.png";